import { render, staticRenderFns } from "./TheProductCustomizer.vue?vue&type=template&id=66beb460&"
import script from "./TheProductCustomizer.vue?vue&type=script&lang=js&"
export * from "./TheProductCustomizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66beb460')) {
      api.createRecord('66beb460', component.options)
    } else {
      api.reload('66beb460', component.options)
    }
    module.hot.accept("./TheProductCustomizer.vue?vue&type=template&id=66beb460&", function () {
      api.rerender('66beb460', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/customizer/TheProductCustomizer.vue"
export default component.exports